import { AxiosResponse } from 'axios';
import api from './Api'

export const getAllScheduleInfo = (): Promise<AxiosResponse<IScheduleInfoWebResponse[]>> => {
    return api.get(`/schedule-info/web/v2`)
}